export default __webpack_public_path__ + "static/media/Mithycal__xvid.b7d97282.mp4";